import React from "react"
import Link from "gatsby-link"
import styles from "../styles/layout.module.scss"
import logo from "../../images/logo_white.png"
import favicon from "../favicon.ico"
import Helmet from "react-helmet"
import topPic from "../../images/ted.jpg"

const ListLink = props =>
  <li style={{ display: `inline-block`, marginRight: `1rem`, height: `1rem`}}>
    <Link to={props.to} activeClassName={styles.activeHeaderLink}>
      {props.children}
    </Link>
  </li>

export default ({ children, data }) =>
  <div>
    {/* html.jsへの設定が反映されないのでここでmeta情報を設定 */}
    <Helmet>
      <meta charSet="utf-8" />
      <meta httpEquiv="x-ua-compatible" content="ie=edge" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      {/* favicon */}
      <link rel="shortcut icon" href={favicon} type="image/x-icon" />
      {/* SEO */}
      <meta name="description" content="北海道 札幌のカジュアルなバーでお酒をのみ、科学、哲学、物理学、生物学、地政学、芸術、など、学問の分野を超えて研究発表、トークイベント、セミナー、討論会、勉強会などを行うアカデミックなラウンジ的イベントです。" />
      <meta name="keywords" content="北海道,札幌,バー,お酒,ラウンジ,学問,科学,哲学,物理学,生物学,地政学,社会学,芸術,トリビア,知識,勉強,雑学,研究,発表,トーク,イベント,セミナー,経済,意識高い,ノマド,経営,教育,金融,アカデミック,ラウンジ,居酒屋,ライブ" />
      <meta property="og:site_name" content={data.site.siteMetadata.title} />
      <meta property="og:title" content={data.site.siteMetadata.title} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="http://www.mingaku-sapporo.netlify.com" />
      <meta property="og:image" content={topPic} />
      <meta property="og:description" content="札幌のカジュアルなバーを会場として飲食を楽しみつつ、毎回ひとつのテーマを決め、研究発表(トークイベント)や、勉強会などを行う会です。" />
      {/* FB用設定 */}
      <meta property="fb:app_id" content="297372647428124" />
      {/* Twitter用設定 */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@karuhiko1" />
    </Helmet>

    <header className={styles.header}>
      <div style={{ display: `inline-block`, float: `left`}}>
        <Link to="/" style={{ textShadow: `none`, backgroundImage: `none` }}>
          <img src={logo} style={{ width: `24px`, float: `left`, margin: `0 1rem` }} />
          <h4 style={{ display: `inline`, color: `white`, float: `left`, margin: `.3rem` }}>{data.site.siteMetadata.title}</h4>
        </Link>
      </div>
      <div style={{ display: `inline-block`, float: `left`, height: `40px`}}>
        <ul style={{ listStyle: `none`, marginBottom: 0}}>
          {/* <ListLink to="/" style={{padding: 0}}>Home</ListLink> */}
          <ListLink to="/about/" style={{padding: 0}}>About</ListLink>
          <ListLink to="/archives/" style={{padding: 0}}>Archives</ListLink>
          <ListLink to="/contact/" style={{padding: 0}}>Contact</ListLink>
        </ul>
      </div>
      <div style={{clear:"both"}}></div>
    </header>

    <div className={styles.contentsHolder}>
      {children()}
    </div>

    <footer className={styles.footer}>
      <p>Last update {data.site.siteMetadata.lastUpdate}</p>
    </footer>
  </div>

export const query = graphql`
  query layoutQuery {
    site {
      siteMetadata {
        title
        lastUpdate
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/layouts/index.js